import React, { Component } from 'react';
import {
    Container,
    Header,
    Grid,
    Menu,
    Button,
    Table,
    Icon,
    Image,
    Pagination,
    Loader,
    Label,
    List
} from 'semantic-ui-react';
import { ajaxPost } from '../ajax';
import { checkDateRange, isTaskAvailable } from '../utils';

// Models
import PagibigMonthlyContributionReport from './ReportModels/GovernmentContributionReport/PagibigMonthlyContributionReport';
import PagibigMP2Report from './ReportModels/GovernmentContributionReport/PagibigMP2Report';
import PayrollAdjustmentReportModel from './ReportModels/PayrollAdjustmentReportModel';
import PhilHealthMonthlyContributionReport from './ReportModels/GovernmentContributionReport/PhilHealthMonthlyContributionReport';
import SSSMonthlyContributionReport from './ReportModels/GovernmentContributionReport/SSSMonthlyContributionReport';
import TaxAnnualizationReportModel from './ReportModels/GovernmentContributionReport/TaxAnnualizationReportModel';
import TaxMonthlyContributionReport from './ReportModels/GovernmentContributionReport/TaxMonthlyContributionReport';

// Modals
import MonthlyFilterModal from './ReportModels/GovernmentContributionReport/MonthlyFilterModal';
import TaxAnnualModal from './ReportModels/TaxAnnualModal';

class PayrollReportsModule extends Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state = {
            activeReport: 'Pagibig Monthly Contribution Report',
            reportModel: null,
            rows: [],
            loading: false,
            isFilterActive: false,
            parameters: null,

            // Pagination
            activePage: 1,
            totalPages: 0,
            totalResultsCount: 0,
            itemsPerPage: 20,

            disAbleExport: true,
        };

        this.filter = React.createRef();
    }

    componentDidMount() {
        this._isMounted = true;
        if (this.props.prevState) {
            this.restoreState(this.props.prevState);
        } else {
            this.setReportModel(this.state.activeReport);
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
        if (this.pollingTimer) {
            clearInterval(this.pollingTimer);
        }
        if (this.props.unmountCallback) {
            const stateToSave = { ...this.state };
            delete stateToSave.reportModel;
            this.props.unmountCallback(stateToSave, "PayrollReportsModule");
        }
    }

    restoreState = (prevState) => {
        const reportModel = this.createReportModel(prevState.activeReport);
        this.setState({
            ...prevState,
            reportModel
        });
    }

    createReportModel = (reportType) => {
        switch (reportType) {
            case 'Pagibig Monthly Contribution Report': return new PagibigMonthlyContributionReport();
            case 'Pagibig MP2 Report': return new PagibigMP2Report();
            case 'Payroll Adjustment Report': return new PayrollAdjustmentReportModel();
            case 'PhilHealth Monthly Contribution Report': return new PhilHealthMonthlyContributionReport();
            case 'SSS Monthly Contribution Report': return new SSSMonthlyContributionReport();
            case 'Tax Annualization Report': return new TaxAnnualizationReportModel();
            case 'Tax Monthly Contribution Report': return new TaxMonthlyContributionReport();
            default: return null;
        }
    }

    setReportModel = (reportType) => {
        const reportModel = this.createReportModel(reportType);

        if (this._isMounted) {
            this.setState({
                reportModel,
                activeReport: reportType,
                rows: [],
                totalResultsCount: 0,
                totalPages: 0,
                activePage: 1,
                disAbleExport: true,
                parameters: null,
                isFilterActive: false
            });
        }
    };

    handleReportClick = (report) => {
        this.setReportModel(report);
    };

    showFilters = () => {
        if (this.state.loading) {
            alert("Please wait until the process is done.");
            return;
        }
        this.setState({ isFilterActive: true });
    }

    btnGenerate_Click = () => {
        if (!this.filter.current) return;
        const params = this.filter.current.getParameters();
        this.runSearchWithParams(params);
    }

    runSearchWithParams = (params) => {
        if (!params) {
            alert("Select filter parameter first.");
            return;
        }

        // Validate Date Range if present (used in Tax Annualization Report / TaxAnnualModal)
        if (params.fromDate !== undefined && params.toDate !== undefined) {
            var checkDateParam = checkDateRange(params.fromDate, params.toDate);
            if (!checkDateParam.Result) {
                alert(checkDateParam.Message);
                return;
            }
        }

        this.setState({ parameters: params, isFilterActive: false, activePage: 1 }, () => {
            setTimeout(() => {
                if (this._isMounted) {
                    this.setState({ disAbleExport: false }, this.onSearch);
                }
            }, 500);
        });
    }

    onSearch = () => {
        this.setState({ rows: [], loading: true });
        const { parameters, activePage, itemsPerPage, reportModel, activeReport } = this.state;

        let searchParams = { ...parameters };
        searchParams.pageNumber = activePage;
        searchParams.itemsPerPage = itemsPerPage;
        searchParams.ReportTitle = activeReport;
        searchParams.startingIndex = (activePage - 1) * itemsPerPage;

        console.log('PayrollReportsModule - onSearch called');
        console.log('PayrollReportsModule - activeReport:', activeReport);
        console.log('PayrollReportsModule - searchParams:', searchParams);

        // Payroll reports that use background processing
        const backgroundReports = [
            'Pagibig Monthly Contribution Report',
            'Pagibig MP2 Report',
            'PhilHealth Monthly Contribution Report',
            'SSS Monthly Contribution Report',
            'Tax Monthly Contribution Report',
            'Tax Annualization Report',
            'Payroll Adjustment Report'
        ];

        reportModel.search(
            searchParams,
            (data) => {
                console.log('PayrollReportsModule - Search response:', data);
                if (backgroundReports.includes(activeReport)) {
                    // Background processing - data is a processId
                    var param = { processId: data };
                    this.startPolling(param, "GENERATE");
                } else {
                    this.populateRows(data);
                }
            },
            (error) => {
                alert("Error:\r\n" + JSON.stringify(error));
                if (this._isMounted) this.setState({ loading: false });
            },
            () => { }
        );
    }

    startPolling = (param, action) => {
        // Clear any existing timer
        if (this.pollingTimer) clearInterval(this.pollingTimer);

        this.pollingTimer = setInterval(() => {
            if (!this._isMounted) {
                clearInterval(this.pollingTimer);
                return;
            }

            ajaxPost({
                data: param,
                url: 'api/BackgroundProcess/GetStatus',
                onSuccess: data => {
                    if (data.Status === "DONE") {
                        clearInterval(this.pollingTimer);

                        setTimeout(() => {
                            if (this._isMounted) {
                                if (action === "GENERATE") {
                                    this.populateRows(JSON.parse(data.ResultParameters));
                                } else if (action === "GENERATE_PDF") {
                                    this.state.reportModel.processSTDPdfData(JSON.parse(data.ResultParameters));
                                    this.setState({ loading: false });
                                } else if (action === "GENERATE_EXCEL") {
                                    this.state.reportModel.exportToExcel(JSON.parse(data.ResultParameters),
                                        data => { },
                                        (err) => { },
                                        () => { }
                                    );
                                    this.setState({ loading: false });
                                }

                                // Clean background process
                                this.cleanBackgroundProcess(param);
                            }
                        }, 100);
                    }
                },
                onError: (error) => {
                    clearInterval(this.pollingTimer);
                    alert("Error status:\r\n" + JSON.stringify(error));
                    if (this._isMounted) this.setState({ loading: false });
                },
                finally: () => { }
            });
        }, 1000); // Check every 1 second
    }

    cleanBackgroundProcess = (param) => {
        setTimeout(() => {
            ajaxPost({
                data: param,
                url: 'api/BackgroundProcess/Delete',
                onSuccess: data => { },
                onError: (err) => { },
                finally: () => { }
            });
        }, 500);
    }

    populateRows = (data) => {
        console.log('PayrollReportsModule - Data received:', data);
        console.log('PayrollReportsModule - data.Data:', data.Data);
        console.log('PayrollReportsModule - data.TotalCount:', data.TotalCount);

        let rows = [];
        if (data.Data) {
            data.Data.forEach(element => {
                rows.push(this.state.reportModel.toTableRow(element));
            });
        }

        // Handle null/undefined TotalCount - default to 0
        const totalCount = data.TotalCount ?? 0;

        let totalPages = 0;
        if (this.state.itemsPerPage > 0 && totalCount > 0) {
            totalPages = Math.ceil(totalCount / this.state.itemsPerPage);
        }

        // Ensure at least 1 page to prevent invalid pagination display
        if (totalPages === 0) {
            totalPages = 1;
        }

        if (this._isMounted) {
            this.setState({
                rows: rows,
                totalResultsCount: totalCount,
                totalPages: totalPages,
                loading: false
            });
        }
    }

    onPageChange = (event, { activePage }) => {
        const page = Math.floor(activePage);
        if (page === this.state.activePage) return;

        this.setState({ activePage: page }, () => {
            if (!this.state.disAbleExport) {
                this.onSearch();
            }
        });
    }

    onExportToExcel = () => {
        const { reportModel, loading, parameters, activeReport } = this.state;
        if (!reportModel) return;

        if (loading) {
            alert("Please wait until the process is done.");
            return;
        }

        this.setState({ loading: true });
        let exportParams = { ...parameters };
        exportParams.pageNumber = 0;
        exportParams.itemsPerPage = 2147483647;
        exportParams.ReportTitle = activeReport;

        // Ensure startingIndex is 0 for export
        exportParams.startingIndex = 0;
        exportParams.itemCount = 2147483647;

        exportParams.sessionId = global.sessionId;

        reportModel.exportToExcelData(
            exportParams,
            (data) => {
                // Excel export uses background processing
                var param = { processId: data };
                this.startPolling(param, "GENERATE_EXCEL");
            },
            (error) => {
                console.error("Export Error:", error);
                const msg = error.message || (typeof error === 'string' ? error : JSON.stringify(error));
                alert("Error:\r\n" + msg);
                if (this._isMounted) this.setState({ loading: false });
            },
            () => { }
        );
    }

    onExportToPdf = () => {
        const { reportModel, loading, parameters, activeReport } = this.state;
        if (!reportModel) return;

        if (loading) {
            alert("Please wait until the process is done.");
            return;
        }

        this.setState({ loading: true });
        let exportParams = { ...parameters };
        exportParams.ReportTitle = activeReport;
        exportParams.itemCount = 2147483647;
        exportParams.itemsPerPage = 2147483647;
        exportParams.pageNumber = 0;
        exportParams.startingIndex = 0;

        reportModel.exportToPdf(
            exportParams,
            (data) => {
                reportModel.processSTDPdfData(data);
                if (this._isMounted) this.setState({ loading: false });
            },
            (error) => {
                alert("Error:\r\n" + JSON.stringify(error));
                if (this._isMounted) this.setState({ loading: false });
            },
            () => { }
        );
    }

    renderFilters = () => {
        const { activeReport, isFilterActive } = this.state;
        if (!isFilterActive) return null;

        const commonProps = {
            ref: this.filter,
            open: true,
            onSave: this.btnGenerate_Click,
            onCancel: () => this.setState({ isFilterActive: false }),
            title: activeReport,
            parameters: this.state.parameters
        };

        // Tax Annualization Report uses Tax Annual Modal (date range for year)
        if (activeReport === 'Tax Annualization Report') {
            return <TaxAnnualModal {...commonProps} />;
        }

        // All other payroll reports (including Payroll Adjustment Report) use Monthly filter
        return <MonthlyFilterModal {...commonProps} />;
    }

    render() {
        const { activeReport, rows, loading, totalResultsCount, activePage, totalPages, disAbleExport } = this.state;

        const reports = [
            'Pagibig Monthly Contribution Report',
            'Pagibig MP2 Report',
            'Payroll Adjustment Report',
            'PhilHealth Monthly Contribution Report',
            'SSS Monthly Contribution Report',
            'Tax Annualization Report',
            'Tax Monthly Contribution Report'
        ];

        return (
            <Container fluid>
                <Header as="h2" style={{ marginBottom: '16px' }}>
                    Payroll Reports
                </Header>

                <Grid>
                    <Grid.Column width={3}>
                        <List selection verticalAlign='middle'>
                            {reports.map((report) => {
                                const isActive = activeReport === report;
                                const style = {
                                    cursor: 'pointer',
                                    color: isActive ? '#000' : '#888',
                                    fontWeight: isActive ? 600 : 400,
                                    padding: '10px',
                                    backgroundColor: isActive ? '#f0f0f0' : 'transparent',
                                    borderRadius: '4px'
                                };
                                return (
                                    <List.Item key={report} onClick={() => this.handleReportClick(report)} style={style}>
                                        <List.Content>
                                            <List.Header>{report}</List.Header>
                                        </List.Content>
                                    </List.Item>
                                );
                            })}
                        </List>
                    </Grid.Column>

                    <Grid.Column width={13}>
                        <div style={{ padding: 0, marginTop: '1em', display: 'flex', flexDirection: 'column', height: 'calc(100vh - 150px)' }}>
                            <Header as="h3">{activeReport}</Header>

                            <div style={{ zIndex: 1000, position: 'relative', margin: '0.5em 0.1em' }}>
                                <Menu secondary size="mini" stackable>
                                    <Button size="mini" content="Generate" onClick={this.showFilters} />
                                    <Button size="mini" content="Export To Excel" disabled={disAbleExport} onClick={this.onExportToExcel} />
                                    <Button size="mini" content="Export To PDF" disabled={disAbleExport} onClick={this.onExportToPdf} />
                                    <Loader active={loading} inline='left' style={{ margin: '0 0.5em' }}  />
                                    
                                    <Menu.Menu position="right">
                                        <Label>Total Results Count: {totalResultsCount}</Label>
                                        <Pagination
                                            size="mini"
                                            activePage={activePage}
                                            totalPages={totalPages}
                                            onPageChange={this.onPageChange}
                                            firstItem={{ content: <Icon name='angle double left' />, icon: true }}
                                            lastItem={{ content: <Icon name='angle double right' />, icon: true }}
                                            prevItem={{ content: <Icon name='angle left' />, icon: true }}
                                            nextItem={{ content: <Icon name='angle right' />, icon: true }}
                                        />
                                    </Menu.Menu>
                                </Menu>
                            </div>

                            <div style={{ flex: 1, overflow: 'auto', border: '1px solid rgba(34,36,38,.15)', borderRadius: '4px' }}>
                                <Table celled striped compact size='small' style={{ border: 'none' }}>
                                    <Table.Header>
                                        {this.state.reportModel && this.state.reportModel.createColumnHeaders()}
                                    </Table.Header>
                                    <Table.Body>
                                        {rows}
                                    </Table.Body>
                                </Table>
                            </div>
                        </div>
                    </Grid.Column>
                </Grid>
                {this.renderFilters()}
            </Container>
        );
    }
}

PayrollReportsModule.getViewID = () => {
    return "PayrollReportsModule";
};

PayrollReportsModule.getCaption = () => {
    return "Payroll Reports";
};

PayrollReportsModule.getViewAccessKey = () => {
    return isTaskAvailable("PAYROLL_VIEW") ? true : false
};

PayrollReportsModule.getIcon = () => {
    return (<Image style={{ height: "24px", width: "24px" }} src="/Icons/Reports.png" avatar />);
};

PayrollReportsModule.getIconSrc = (size) => {
    return '/Icons/Reports.png';
};

export default PayrollReportsModule;
